const state = {
  news: [
    {
      id: 1,
      title: '公司荣获"高新技术企业"认证',
      summary: '经过严格的评审和考核，我公司成功获得高新技术企业认证，这标志着公司在技术创新和研发能力方面得到了权威认可。',
      content: '近日，我公司顺利通过高新技术企业认证评审，正式获得"高新技术企业"称号。这一认证的获得，充分证明了公司在技术创新、产品研发、知识产权等方面的综合实力。作为专业的IT技术服务提供商，我们一直致力于为客户提供最优质的技术解决方案，此次认证是对我们技术实力和服务水平的高度肯定。',
      image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800',
      date: '2024-01-15',
      category: '公司新闻',
      tags: ['高新技术企业', '认证', '技术创新']
    },
    {
      id: 2,
      title: '智能小镇管理系统成功上线',
      summary: '我公司为某市政府开发的智能小镇管理系统正式上线运行，该系统将大幅提升城市管理效率和智能化水平。',
      content: '经过数月的精心开发和测试，我公司承建的智能小镇管理系统在某市正式上线运行。该系统集成了物联网、大数据、云计算等先进技术，实现了城市管理的智能化、精细化和高效化。系统上线后，将有效提升城市运行效率，改善市民生活质量，为智慧城市建设提供强有力的技术支撑。',
      image: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800',
      date: '2024-01-10',
      category: '项目动态',
      tags: ['智慧城市', '系统上线', '物联网']
    },
    {
      id: 3,
      title: '大数据管理系统助力企业数字化转型',
      summary: '我公司开发的大数据管理系统成功帮助多家大型企业实现数字化转型，获得客户一致好评。',
      content: '近日，我公司开发的大数据管理系统在多家大型企业成功部署并稳定运行，有效支撑了企业的数字化转型需求。该系统具备强大的数据处理和分析能力，能够帮助企业从海量数据中挖掘价值，实现数据驱动的科学决策。多家客户反馈，系统运行稳定，功能完善，显著提升了企业的运营效率和市场竞争力。',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800',
      date: '2024-01-05',
      category: '技术动态',
      tags: ['大数据', '数字化转型', '企业应用']
    }
  ]
}

const mutations = {
  // 新闻相关mutations
}

const actions = {
  // 新闻相关actions
}

const getters = {
  getNewsById: (state) => (id) => {
    return state.news.find(item => item.id === parseInt(id))
  },
  getLatestNews: (state) => (count = 3) => {
    return state.news.slice(0, count)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}